import utility from "core/Utils";
import Select from "components/elements/Select";
import IconInput from "components/elements/IconInput";
import { useState } from "react";
import { useEffect } from "react";
import dataProvider from "core/DataProvider";
import Modal from "components/elements/Modal";
import Table from "components/elements/Table";
import { ReactComponent as DownloadIcon } from "../../../images/download.svg";
import Exporter from "components/elements/Exporter";

const headerMap = {
  content_language_code: "Content Language Code",
  content_language: "Content Language",
};

const exportHeaders = [
  { key: "content_language_code", label: "Content Language Code" },
  { key: "content_language", label: "Content Language" },
];

const ContentLanguageMaster = props => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [exportFormat, setExportFormat] = useState({
    value: "csv",
    label: "CSV",
  });

  const [columns] = useState(utility.optionFromObject(headerMap));
  const [selectedColumns, setSelectedColumns] = useState(
    utility.optionFromObject(headerMap)
  );
  const [showColModal, setShowColModal] = useState(false);

  const fetchData = async () => {
    let data = await dataProvider.network.get("/masters/content-language");
    setData(data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const colModal = (
    <Modal onClose={() => setShowColModal(false)}>
      <h3>Select Columns</h3>
      <div className="full-row" style={{ width: "50vw", marginTop: "2rem" }}>
        <Select
          isMulti
          value={selectedColumns}
          options={columns}
          placeholder="Select columns to show"
          onChange={val => setSelectedColumns(val)}
        />
      </div>
    </Modal>
  );

  return (
    <section id="contentlanguage-master">
      {showColModal && colModal}
      <div className="grey-box">
        <div className="left">
          <h3>Content Language Master</h3>
          <h4>Masters &gt; Content Language Master</h4>
        </div>
        <div className="right">
          {/* <div className="stat">
            <span>{count}</span>
            <span>Available Data</span>
          </div>
          <div className="stat">
            <span>12-02-2022</span>
            <span>
              <CalenderDay />
            </span>
          </div> */}
        </div>
      </div>
      <div className="mtop">
        <div className="pbox flex-full">
          <div className="head flex flex-v-center">
            <div className="right">
              <div className="flex flex-v-center">
                <div className="el">
                  <input
                    type="text"
                    readOnly
                    placeholder="Select Columns"
                    onClick={e => {
                      e.preventDefault();
                      setShowColModal(true);
                    }}
                  />
                </div>
                <div className="el">
                  <IconInput
                    placeholder="Search"
                    icon="search"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                  />
                </div>
                <div className="el">
                  <Select
                    value={exportFormat}
                    onChange={val => {
                      setExportFormat(val);
                    }}
                    options={[{ value: "csv", label: "CSV" }]}
                    placeholder="Format"
                  />
                </div>
                <Exporter
                  format={exportFormat.value}
                  data={data}
                  headers={exportHeaders}
                  filename={`ContentLanguageMaster_${utility.formatDate(
                    new Date()
                  )}.${exportFormat.value}`}
                />
              </div>
            </div>
          </div>
          <div className="results">
            <Table
              headers={utility.objectFromOptions(selectedColumns)}
              data={data}
              search={search}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContentLanguageMaster;
